import { useEffect, useState } from 'react';

export type Option = {
  id: string;
  label: string;
};

type UseDisplayLanguageHandleDropdownProps = {
  options: Option[];
  value: Option[];
  onChange: (selectedOptions: Option[]) => void;
};

const useDisplayLanguageHandleDropdown = ({
  options,
  value,
  onChange,
}: UseDisplayLanguageHandleDropdownProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCheckboxChange = (id: string) => {
    setSelectedOptions(prevSelected => {
      let updatedSelectedOptions;
      updatedSelectedOptions = prevSelected.includes(id)
        ? prevSelected.filter(item => item !== id)
        : [...prevSelected, id];

      // Call onChange with the updated state
      onChange(
        updatedSelectedOptions.map(selectedOption =>
          options.find(option => option.id === selectedOption),
        ),
      );

      return updatedSelectedOptions;
    });
  };

  useEffect(() => {
    setSelectedOptions(value.map(option => option.id));
  }, [value]);

  return {
    anchorEl,
    selectedOptions,
    handleClick,
    handleClose,
    handleCheckboxChange,
    options,
  };
};

export default useDisplayLanguageHandleDropdown;
